export default {
  'error.message.403.description':
    'Sorry, you are not authorized to access this page.',
  'error.message.404.description':
    'Sorry, the page you visited does not exist.',
  'error.message.unknown': 'An error occurred!',
  'error.message.ERROR_MODULE_HAS_BEEN_REGISTERED':
    'Module has been registered.',
};
